import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router';
import { get } from 'lodash';
import Logo from '../../common/svgs/Logo';
const copyRightLogoStyle= { color: '#dcdcdc', width: '88px' };
@connect(store => ({
  labels: get(store.labels, 'Common', {}),
}))
export default class Copyright extends Component {
  static propTypes = {
    className: PropTypes.string,
    labels: PropTypes.object
  }

  render() {
      const classes = ['copyright-container'];
      if (this.props.className) {
        classes.push(this.props.className);
      }

      return (
        <div className={classes.join(' ')}>
          <Logo style={copyRightLogoStyle}/>
            <div className='copyright-text'>
              Copyright © {(new Date().getFullYear())}. <br/>
              {get(this.props.labels, 'fullName')}<br/>
                All rights reserved.
                <a target="_blank" className="link terms-link" data-id="Terms Link" href={this.props.labels.privacy}> Privacy Policy</a>
              <br/>
            </div>
        </div>

    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_copyright/index.js